import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScoraModalModuleComponent } from './scora-modal-module.component';
import { DocPdfModalViewComponent } from "../scora-modal-module/doc-pdf-modal-view/doc-pdf-modal-view.component";
import { ImageModalViewComponent } from "./image-modal-view/image-modal-view.component";
import { FeedbackCommentModalComponent } from "./feedback-comment-modal/feedback-comment-modal.component";
import { LearningSupportModalComponent } from "./learning-support-modal/learning-support-modal.component";
import { RubricViewModalComponent } from "./rubric-view-modal/rubric-view-modal.component";
import { InsightTableModalComponent } from "./insight-table-modal/insight-table-modal.component";
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { ModalModule, PopoverModule } from 'ngx-bootstrap';
import {SafePipe} from '../../pipe/safe.pipe';
import { SharedControlsModule } from "../shared-controls/shared-controls.module";

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    SharedControlsModule
  ],
  declarations: [
    SafePipe,
    ScoraModalModuleComponent,
    DocPdfModalViewComponent,
    ImageModalViewComponent,
    FeedbackCommentModalComponent,
    LearningSupportModalComponent,
    RubricViewModalComponent,
    InsightTableModalComponent,
    ChangePasswordModalComponent
  ],
  exports: [
    DocPdfModalViewComponent,
    ImageModalViewComponent,
    FeedbackCommentModalComponent,
    LearningSupportModalComponent,
    RubricViewModalComponent,
    InsightTableModalComponent,
    ChangePasswordModalComponent
  ]
})
export class ScoraModalModuleModule { }



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/scora-modal-module.module.ts